import { USER_GENERIC_NAME } from "../utils/constants";
import { SET_USER_ALIAS_ACTION } from "./reducersConstants";

export const setUserAliasAction = (data) => {
  return {
    type: SET_USER_ALIAS_ACTION,
    data,
  };
};

export const userAliasReducer = (previousState = USER_GENERIC_NAME, { type, data }) => {
  switch (type) {
    case SET_USER_ALIAS_ACTION:
      return data;
    default:
      return previousState;
  }
};
